module.exports = __webpack_public_path__ + "img/1.a97fec8f.png";